namespace $ {
	export class $shm_hitalama_map_transfer_file extends $mol_object {

		static blobs = new Map< string, Blob >

		static blob_from_uri( uri?: string ) {
			if( !uri ) return null
			const cached = this.blobs.get( uri )
			if( cached ) return cached

			let blob: Blob | null = null

			if( uri.startsWith( 'data:' ) ) {
				const comma = uri.indexOf( ',' )
				if( comma === -1 ) return null

				const meta = uri.slice( 5, comma )
				const data = uri.slice( comma + 1 )
				const mime = meta.split( ';' )[0] || undefined

				if( meta.split( ';' ).includes( 'base64' ) ) {
					blob = new Blob( [ $mol_base64_decode( data.replace( /\s/g, '' ) ) ], { type: mime } )
				} else {
					blob = new Blob( [ decodeURIComponent( data ) ], { type: mime } )
				}
			} else {
				blob = this.$.$mol_wire_sync(this.$.$mol_fetch).blob( uri )
			}

			this.blobs.set( uri, blob )
			return blob
		}
		
		@ $mol_action
		static serialize( file: $shm_hitalama_file ) {
			const blob_uri = file.$.$mol_wire_sync(file).blob_uri_async()
			return {
				ref: file.link().toString(),

				title: file.title(),
				size: file.Size()?.val(),
				blob_uri,
			}
		}

		@ $mol_action
		static deserialize( file: $shm_hitalama_file, dto: ReturnType< typeof $shm_hitalama_map_transfer_file['serialize'] > ) {
			file.title( dto.title )
			file.Size(null)?.val( dto.size )

			const blob = this.blob_from_uri( dto.blob_uri )
			if( !blob ) return

			file.write_to_opfs( blob )
		}
		
	}
}
